import { useLayoutEffect, useState } from "react";
import Cookies from "js-cookie";
import styles from "./Train.module.scss";
import { env } from "../../env";

const Train = () => {
  useRemoveBodyScroll();
  const [accessToken] = useState(Cookies.get("ACCESS_TOKEN"));
  const iframeSrc = getIframeSrc(accessToken!);

  return (
    <div className={styles.root}>
      <iframe title="Train" className={styles.frame} src={iframeSrc} />
    </div>
  );
};

const getIframeSrc = (token: string) => {
  return `${env.TRAIN_BASE_URL}/coaching/programming?embeded=true&token=${token}`;
};

const useRemoveBodyScroll = () => {
  useLayoutEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);
};

export default Train;
